export {
    createWorldMatrix,
    customStartPropAssetKeys,
    type CustomPlatformAssemblyConfig,
    type CustomPlatformPropPlacementConfig,
    type CustomStartPropAssetKey,
    type IndividualContentPlatformPlacementConfig,
} from './IndividualPlatformTypes'

import {
    level1CustomPlatformAssemblies,
    level1CustomPlatformPropPlacements,
    level1IndividualContentPlatformPlacements,
} from './IndividualPlatformsLevel1'
import {
    level2CustomPlatformAssemblies,
    level2CustomPlatformPropPlacements,
    level2IndividualContentPlatformPlacements,
} from './IndividualPlatformsLevel2'
import {
    level3CustomPlatformAssemblies,
    level3CustomPlatformPropPlacements,
    level3IndividualContentPlatformPlacements,
} from './IndividualPlatformsLevel3'
import {
    level4CustomPlatformAssemblies,
    level4CustomPlatformPropPlacements,
    level4IndividualContentPlatformPlacements,
} from './IndividualPlatformsLevel4'

export const customPlatformAssemblies = [
    ...level1CustomPlatformAssemblies,
    ...level2CustomPlatformAssemblies,
    ...level3CustomPlatformAssemblies,
    ...level4CustomPlatformAssemblies,
] as const

export const customPlatformPropPlacements = [
    ...level1CustomPlatformPropPlacements,
    ...level2CustomPlatformPropPlacements,
    ...level3CustomPlatformPropPlacements,
    ...level4CustomPlatformPropPlacements,
] as const

export const individualContentPlatformPlacements = [
    ...level1IndividualContentPlatformPlacements,
    ...level2IndividualContentPlatformPlacements,
    ...level3IndividualContentPlatformPlacements,
    ...level4IndividualContentPlatformPlacements,
] as const
